module.exports = __webpack_public_path__ + "img/team-parcel-logo.36e73113.png";